import { apiSlice } from "./apiSlice";

export const adminContractApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({

        // 계약서 리스트 조회
        getContractGroupListAdmin: build.query({
            query: (params) => ({
                url: "/api/admin/contract_group/v1",
                method: "get",
                headers: { token: true },
                params,
            }),
        }),

        // 계약 그룹 상세조회 (계약 그룹 전체 상세조회)
        getContractGroupByIdAdmin: build.query({
            query: (contractGroupId) => ({
                url: `/api/admin/contract_group/v1/${contractGroupId}`,
                method: "get",
                headers: { token: true },
            }),
        }),
        // 계약서 저장
        postContractGroupAdmin: build.mutation({
            query: (body) => ({
                url: "/api/admin/contract_group/v1",
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),

        // 계약서 수정
        putContractGroupAdmin: build.mutation({
            query: ({ contractGroupId, body }) => ({
                url: `/api/admin/contract_group/v1/${contractGroupId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),
        // 계약종결
        putContractGroupFinishAdmin: build.mutation({
            query: ({ contractGroupId }) => ({
                url: `/api/admin/contract_group/v1/${contractGroupId}/finish`,
                method: "put",
                headers: { token: true },
            }),
        }),

        // 계약서 단건 상세조회 (계약 그룹 내 개별 계약 조회)
        getContractGroupContractByIdAdmin: build.query({
            query: ({ contractGroupId, contractId }) => ({
                url: `/api/admin/contract_group/v1/${contractGroupId}/contract/${contractId}`,
                method: "get",
                headers: { token: true },
            }),
        }),
        // 전자계약 발송
        sendContractAdmin: build.mutation({
            query: ({ contractGroupId, contractId, body }) => ({
                url: `/api/admin/contract_group/v1/${contractGroupId}/contract/${contractId}/send`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 계약서 차량 반납처리
        returnContractAdmin: build.mutation({
            query: ({ contractGroupId, contractId, body }) => ({
                url: `/api/admin/contract_group/v1/${contractGroupId}/contract/${contractId}/return`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 싸인 완료 계약서 PDF 파일 저장
        signContractPdfAdmin: build.mutation({
            query: ({ contractGroupId, contractId, body }) => ({
                url: `/api/admin/contract_group/v1/${contractGroupId}/contract/${contractId}/sign_contract/pdf`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),





    }),
});

export const {
    useGetContractGroupListAdminQuery,
    useGetContractGroupByIdAdminQuery,
    usePostContractGroupAdminMutation,
    usePutContractGroupAdminMutation,
    usePutContractGroupFinishAdminMutation,
    useGetContractGroupContractByIdAdminQuery,
    useSendContractAdminMutation,
    useReturnContractAdminMutation,
    useSignContractPdfAdminMutation,
} = adminContractApi;
